import { handleErrors } from '.';

import { useStore } from '../store';

import type { SignUpFormData } from '../types/forms/signupform';

export const APIsetupAuth = async () => (
  window.axios.get('/sanctum/csrf-cookie')
);

export const APIlogin = async (email: string, password: string) => (
  window.axios.post('/api/login', { email, password })
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIlogout = async () => (
  window.axios.post('/api/logout')
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIsignUp = async (params: SignUpFormData) => (
  window.axios.post('/api/signup', params)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIemailConfirmation = async (token: string) => (
  window.axios.post('/api/signup/confirm', { token })
    .then((response) => (response))
    .catch((error) => error)
);

export const APIsendConfirmationEmail = async (email: string) => (
  window.axios.post('/api/signup/send-confirmation-email', { email })
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIpasswordReset = async (email: string) => (
  window.axios.post('/api/password/reset', { email })
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIpasswordChange = async (token: string, password: string) => (
  window.axios.post('/api/password/change', { token, password })
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchProfile = async () => (
  window.axios.get('/api/user')
    .then((response) => (response))
    .catch((error) => (error))
);

export const loadUserProfile = async () => {
  try {
    const response = await APIfetchProfile();
    if (response?.data) {
      useStore.setState({ settings: response.data?.settings });
      delete response.data.settings;
      if (response.data.id || response.data.anonymous) {
        useStore.setState({ profile: response.data });
      } else {
        useStore.setState({ profile: null });
      }
      return response.data;
    }
  } catch (error: any) {
    if (error.status === 401) {
      useStore.setState({ profile: null });
      return null;
    }
    console.error('Error fetching profile:', error);
    useStore.setState({ profile: null });
  }
  return null;
};
